import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {UpdateArchivableParams} from 'app-core/platform/archivable/CoreObjectArchiveConstants';
import {Section} from 'constants/NavConstants';
import {getStore} from 'redux-stores/Store';
import {forceRefreshSearch} from 'search/SearchUIReduxActions';
import {patchJSONPromise, postJSONPromise} from 'util/Net';

export interface CreateDatasetParams {
  name: string;
  folderId: string;
  dataFrameId?: string;
  studyIds?: Array<string>;
}

export interface CreateDatasetResponse {
  createdIds: Array<string>;
}

export async function createDataset(dataset: CreateDatasetParams): Promise<CreateDatasetResponse> {
  const creates = [dataset];
  const response: CreateDatasetResponse = await postJSONPromise({
    url: getApiBaseForObjectType(DomainGraphType.DATASET),
    data: {creates},
  });
  getStore().dispatch(forceRefreshSearch(Section.SEARCH));
  return response;
}

export interface CreateDatasetFromFileParams {
  name: string;
  folderId: string;
  s3Location: string;
  delimiter?: string;
  locale?: string;
  sheetName?: string;
  studyIds?: Array<string>;
}

export async function createDatasetFromFile(
  params: CreateDatasetFromFileParams
): Promise<CreateDatasetResponse> {
  const creates = [params];
  const response: CreateDatasetResponse = await postJSONPromise({
    url: getApiBaseForObjectType(DomainGraphType.DATASET),
    data: {creates},
  });
  getStore().dispatch(forceRefreshSearch(Section.SEARCH));
  return response;
}

export interface UpdateDatasetParams extends UpdateArchivableParams {
  id: string;
  name?: string;
}

export interface UpdateDatasetResponse {
  updatedIds: Array<string>;
}

export function updateDataset(dataset: UpdateDatasetParams): Promise<UpdateDatasetResponse> {
  const updates = [dataset];
  return patchJSONPromise({url: getApiBaseForObjectType(DomainGraphType.DATASET), data: {updates}});
}
